import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["answer", "icon", "toggleText"];

  toggle(event) {
    const button = event.currentTarget;
    const answer = button.nextElementSibling;
    const icon = button.querySelector("[data-faq-target='icon']");
    const toggleText = button.querySelector("[data-faq-target='toggleText']");

    const isHidden = answer.classList.toggle("hidden");

    // Rotate the icon
    icon.style.transform = isHidden ? "rotate(0deg)" : "rotate(180deg)";

    // Toggle the text between show and hide
    toggleText.textContent = isHidden ? "Show" : "Hide";
  }
}
